import styled from 'styled-components';

const Button = styled.button`
  padding: ${({ theme }) => theme.form.inputPadding};
  min-width: ${({ theme }) => theme.form.buttonMinWidth};
  height: ${({ theme }) => theme.form.buttonHeight};
  background-color: ${({ theme }) => theme.colors.buttonBg};
  color: ${({ theme }) => theme.colors.buttonText};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
  }
`;

export default Button;